import {ApolloLink} from '@apollo/client';
import createSplitBySchemaLink from 'src/internal/revamp/links/createSplitBySchemaLink';

import type {SchemaLinksConfiguration} from 'src/internal/revamp/links/createSchemaLinksConfiguration';

const WILDCARD = '*';

const errorLink = new ApolloLink(function errorLink() {
  throw new Error(
    'Wildcard schema exists (*) but does not have an apollo link assigned. Please make sure to assign an apollo link to it.',
  );
});

export default function createRouteToTestOrRealSchemaLink(
  schemaLinksConfiguration: SchemaLinksConfiguration,
): ApolloLink {
  const wildcardConfig = Object.keys(
    schemaLinksConfiguration.schemaIdToApolloLink,
  ).find((schemaId) => schemaId === WILDCARD);

  const rightLink = wildcardConfig
    ? schemaLinksConfiguration.schemaIdToApolloLink[wildcardConfig]
    : errorLink;

  return ApolloLink.split(
    () => typeof wildcardConfig === 'undefined',
    createSplitBySchemaLink(schemaLinksConfiguration),
    rightLink,
  );
}
